import { addAttachmentToHistoryEntry } from "../../api/historyService";

export const useAddAttachmentToHistoryEntry = (successCallback) => {
  const attachToEntry = async (id, data) => {
    try {
        const newRecord = await addAttachmentToHistoryEntry(id, data);
        if (successCallback) successCallback(newRecord);
        return newRecord;
    } catch (error) {
        console.error("Failed to attach file to history entry:", error);
        throw error;
    }
  };

  return { attachToEntry };
};